module.exports = __webpack_public_path__ + "static/img/qrCode.5f0f5bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/happyBirthday/qrCode.png
// module id = WMJA
// module chunks = 1